import { ReactNode } from 'react';
import { Action } from './Action/action';
import { ActionGroup } from './ActionGroup/action-group';
import { AssistantMessage } from './AssistantMessage/assistant-message';
import { Card } from './Card/card';
import { CardGroup } from './CardGroup/card-group';
import { Event } from './Event/event';
import { EventGroup } from './EventGroup/event-group';
import { File } from './File/file';
import { FormRecap } from './FormRecap/FormRecap';
import { FormRecapError } from './FormRecapError/FormRecapError';
import { FormRecapSuccess } from './FormRecapSuccess/FormRecapSuccess';
import { FormRequest } from './FormRequest/FormRequest';
import { Image } from './Image/image';
import { NotFound } from './NotFound/not-found';
import { Poi } from './Poi/poi';
import { PoiGroup } from './PoiGroup/poi-group';
import { Product } from './Product/product';
import { ProductGroup } from './ProductGroup/product-group';
import { ProductGroupSlider } from './ProductGroupSlider/product-group-slider';
import { StreamError } from './StreamError/StreamError';
import { TripAdvisor, TripAdvisorGroup } from './Tripadvisor/tripadvisor';
import { UserMessage } from './UserMessage/user-message';

export const LLM_BLOCKS = {
  action: Action,
  actionGroup: ActionGroup,
  assistantMessage: AssistantMessage,
  card: Card,
  cardGroup: CardGroup,
  event: Event,
  eventGroup: EventGroup,
  file: File,
  formRecap: FormRecap,
  formRecapError: FormRecapError,
  formRecapSuccess: FormRecapSuccess,
  formRequest: FormRequest,
  image: Image,
  notFound: NotFound,
  poi: Poi,
  poiGroup: PoiGroup,
  product: Product,
  productGroup: ProductGroup,
  productGroupSlider: ProductGroupSlider,
  error: StreamError,
  tripAdvisor: TripAdvisor,
  tripAdvisorGroup: TripAdvisorGroup,
  userMessage: UserMessage,
};

export type LlmBlocks = Record<string, ((props: any) => ReactNode | Promise<ReactNode>) | undefined> & typeof LLM_BLOCKS;
